import { API } from "../../../utils";

export const getTenantAndroidSettingsApi = async () => {
  const res = await API.get("/settings/android");
  return res.data;
};

export const updateTenantAndroidSettingsApi = async (payload) => {
  const res = await API.put("/settings/android", payload);
  return res.data;
};

export const getTenantIosSettingsApi = async () => {
  const res = await API.get("/settings/ios");
  return res.data;
};

export const updateTenantIosSettingsApi = async (payload) => {
  const res = await API.put("/settings/ios", payload);
  return res.data;
};
